/* istanbul ignore file */
import { theme } from '@noths/polaris-client-ribbons-base';
import { applyKeyframe } from '@noths/polaris-client-styles';
import { css, keyframes } from 'styled-components';

const { fonts, spacing } = theme;

const primaryRegularFont = css`
  font-family: ${fonts.PRIMARY_REGULAR.family};
  font-weight: ${fonts.PRIMARY_REGULAR.weight};
`;

const appear = keyframes`
  from {
    opacity: 0;
    transform: translateY(-50%);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const errorField = css`
  display: flex;
  align-items: center;

  &[data-icon-align='left'] {
    flex-direction: row-reverse;
  }
`;

export const errorIconLeft = css`
  pointer-events: none;
  margin-right: ${spacing.base}px;
`;

export const errorIconRight = css`
  pointer-events: none;
  margin-left: ${spacing.base}px;
`;

export const feedbackName = css`
  animation: ${applyKeyframe(appear)} 0.25s ease-in-out;
  animation-fill-mode: forwards;
  ${theme.responsiveText.BODY.XS};
  ${primaryRegularFont}
  margin-right: auto;
  color: var(--neutral-black-base);

  &[data-has-error='true'] {
    color: var(--functional-red-base);
  }
`;

export const feedbackValue = css`
  ${theme.responsiveText.BODY.XS};
  ${primaryRegularFont}
  margin-left: auto;
  color: var(--neutral-black-base);

  &[data-has-error='true'] {
    color: var(--functional-red-base);
  }
`;
